import type { TooltipProps } from './Tooltip.props';
import { StyledTooltip } from './Tooltip.styles';

const Tooltip = (props: TooltipProps) => <StyledTooltip {...props} />;

export default Tooltip;
